
import { Component, Prop, Vue } from 'vue-property-decorator';
import { WebsiteComposite } from '@/services/Website/interfaces';

@Component
export default class RetryActionPanel extends Vue {
  @Prop({ type: Object, required: true })
  public composite!: WebsiteComposite;

  @Prop({ type: Boolean, default: false })
  public busy!: boolean;

  @Prop({ type: String, default: '' })
  public errorMessage!: string;

  @Prop({ type: Number, required: true })
  public creationId!: number;

  @Prop({ type: Number, required: true })
  public actionId!: number;

  @Prop({ type: String, required: true })
  public actionName!: string;

  public get domain(): string {
    return this.composite.website.domain;
  }

  public onSubmit(): void {
    this.$emit('submit', { creationId: this.creationId, actionId: this.actionId });
  }
}
